import { Helmet } from "react-helmet";
import Header from "../../../../Components/Header";
import Itemtax from "./Itemtax";
const CreateitemTax = () => {
  return (
    <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
      <Helmet>
				<title>Item Tax Template - Edit</title>
			</Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column" style={{ flexGrow: '1' }}>
        <Itemtax />
      </div>
    </div>
  );
};

export default CreateitemTax;
